import React from "react";
import "./TaskTarget.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTaskTarget } from "../../actions/userActions/tasks/taskTargetAction";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import { getSubOrdinates } from "../../actions/userActions/tasks/taskAction";
import Loader from "../subComponents/Loader";
import { TasksTargetPieChart } from "../subComponents/recharts/TasksTargetPieChart";
import { Tooltip } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, Menu, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import CustomPagination from "../subComponents/pagination/CustomPagination";
import SearchInput from "../subComponents/search/SearchInput";
import DynamicTable from "../reuse_components/DynamicTable";
import { Redirect } from "react-router-dom";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import GenericFilter, { FilterBar } from "../subComponents/Filter/GenericFilters";
import CustomFilterSelect from "../designSystem/CustomFilterSelect";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import CustomTab from "../designSystem/CustomTab.jsx";
import { t } from "../../locales/translate";

const TaskTarget = () => {
  const dispatch = useDispatch();
  const currentDate = moment();
  const [selectedTab, setSelectedTab] = useState("MY TASKS");
  const [showMyTask, setShowMyTask] = useState(true);
  const [showFilters, setShowFilters] = useState(false);

  // Filter states - ONLY THESE, remove duplicates
  const [dateRangeFilter, setDateRangeFilter] = useState('last 7 days');
  const [customDateRange, setCustomDateRange] = useState(false);

  const [filters, setFilters] = useState({
    taskFromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
    taskToDate: moment(currentDate).format("YYYY-MM-DD"),
  });

  const [selected, setSelected] = useState({
    taskFromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
    taskToDate: moment(currentDate).format("YYYY-MM-DD"),
  });

  const [showDetailsForRow, setShowDetailsForRow] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const tasksTarget = useSelector((state) => state.tasks_target_reducer);
  const isLoading = useSelector((state) => state.tasks_target_reducer.isTaskTargetLoading);
  const isSubordinatesLoading = useSelector((state) => state.tasks_reducer.isSubordinatesLoading);
  const auth = useSelector((state) => state.auth);
  const {
    subOrdinates,
    loading,
    totalCount,
    totalPages
  } = useSelector(state => state.tasks_reducer);

  const body = {
    startDate: filters.taskFromDate,
    endDate: filters.taskToDate,
    empId: user.result[0].user.id,
  };

  const id = user.result[0].user.id;

  // Date range options
  const dateRangeOptions = [
    { id: 'today', name: 'Today' },
    { id: 'yesterday', name: 'Yesterday' },
    { id: 'last 7 days', name: 'Last 7 Days' },
    { id: 'last 30 days', name: 'Last 30 Days' },
    { id: 'this month', name: 'This Month' },
    { id: 'last month', name: 'Last Month' },
    { id: 'this year', name: 'This Year' },
    { id: 'last year', name: 'Last Year' },
    { id: 'custom', name: 'Custom Range' }
  ];

  // Toggle filters visibility
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  useEffect(() => {
    if (auth.isLoggedIn === false && !user) {
      return <Redirect to="/" />;
    }
  }, [auth.isLoggedIn, user]);

  useEffect(() => {
    if (selectedTab === "MY TASKS") {
      dispatch(getTaskTarget(body))
        .then(() => {
          dispatch(getSubOrdinates(id, currentPage, itemsPerPage, query));
        });
    } else if (selectedTab === "SubOrdinates") {
      dispatch(getSubOrdinates(id, currentPage, itemsPerPage, query));
    }
    setShowDetailsForRow({});
    setCurrentPage(1);
    setQuery("");
  }, [selectedTab, dispatch]);

  useEffect(() => {
  if (selectedTab === "SubOrdinates") {
    dispatch(getSubOrdinates(id, currentPage, itemsPerPage, query));
  }
  dispatch(getTaskTarget(body))
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
}, [filters]);

  useEffect(() => {
    if (selectedTab === "SubOrdinates") {
      dispatch(getSubOrdinates(id, currentPage, itemsPerPage, query));
    }
  }, [currentPage, query, selectedTab]);

  const handleDetails = (empId, index) => {
    const body = {
      startDate: filters.taskFromDate,
      endDate: filters.taskToDate,
      empId: empId,
    };
    setShowDetailsForRow(prevState => {
      const newState = {
        ...prevState,
        [index]: !prevState[index]
      };
      return newState;
    });
    if (!showDetailsForRow[index]) {
      dispatch(getTaskTarget(body));
    }
  };

  const MyTasksChange = () => {
    setSelectedTab("MY TASKS");
    setShowMyTask(true);
  };

  const SubOrdinatesChange = () => {
    setSelectedTab("SubOrdinates");
    setShowMyTask(false);
  };

  const handleSearch = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };

  // ONLY THIS DATE RANGE HANDLER - remove the old one
 // Update your handleDateRangeChange function to handle the event object:

const handleDateRangeChange = (event) => {
  const value = event?.target?.value || event;
  
  setDateRangeFilter(value);

  let fromDate, toDate;

  switch (value) {
    case 'today':
      setCustomDateRange(false);
      fromDate = moment().format("YYYY-MM-DD");
      toDate = moment().format("YYYY-MM-DD");
      break;
    case 'yesterday':
      setCustomDateRange(false);
      fromDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      toDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      break;
    case 'last 7 days':
      setCustomDateRange(false);
      fromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
      toDate = moment().format("YYYY-MM-DD");
      break;
    case 'last 30 days':
      setCustomDateRange(false);
      fromDate = moment().subtract(29, "days").format("YYYY-MM-DD");
      toDate = moment().format("YYYY-MM-DD");
      break;
    case 'this month':
      setCustomDateRange(false);
      fromDate = moment().startOf("month").format("YYYY-MM-DD");
      toDate = moment().endOf("month").format("YYYY-MM-DD");
      break;
    case 'last month':
      setCustomDateRange(false);
      fromDate = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
      toDate = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
      break;
    case 'this year':
      setCustomDateRange(false);
      fromDate = moment().startOf("year").format("YYYY-MM-DD");
      toDate = moment().endOf("year").format("YYYY-MM-DD");
      break;
    case 'last year':
      setCustomDateRange(false);
      fromDate = moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD");
      toDate = moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD");
      break;
    case 'custom':
      setCustomDateRange(true);
      return;
    default:
      return;
  }

  setCurrentPage(1);
  setSelected({ taskFromDate: fromDate, taskToDate: toDate });
  setFilters({ taskFromDate: fromDate, taskToDate: toDate });
};
  const handleFromDateChange = (date) => {
  const formattedDate = dayjs(date).format('YYYY-MM-DD');
  setCurrentPage(1); 
  setSelected(prevValues => ({
    ...prevValues,
    taskFromDate: formattedDate,
  }));
  setFilters(prevValues => ({
    ...prevValues,
    taskFromDate: formattedDate,
  }));
};

  const handleToDateChange = (date) => {
  const formattedDate = dayjs(date).format('YYYY-MM-DD');
  setCurrentPage(1); 
  setSelected(prevValues => ({
    ...prevValues,
    taskToDate: formattedDate,
  }));
  setFilters(prevValues => ({
    ...prevValues,
    taskToDate: formattedDate,
  }));
};

  const handleClearAllFilters = () => {
  setDateRangeFilter('last 7 days');
  setCustomDateRange(false);
  setCurrentPage(1); 
  const fromDate = moment().subtract(7, "days").format("YYYY-MM-DD");
  const toDate = moment().format("YYYY-MM-DD");
  setSelected({ taskFromDate: fromDate, taskToDate: toDate });
  setFilters({ taskFromDate: fromDate, taskToDate: toDate });
};
  const data = tasksTarget.tasksTarget &&
    tasksTarget.tasksTarget !== "isLoading" &&
    tasksTarget.tasksTarget !== undefined &&
    tasksTarget.tasksTarget &&
    tasksTarget.tasksTarget.filter(item => item.key !== 'Total').map(item => {
      let fill;
      switch (item.key) {
        case 'Created':
          fill = '#87A2C7';
          break;
        case 'In Review':
          fill = '#E1A900';
          break;
        case 'Approved':
          fill = '#2ECC71';
          break;
        case 'Rejected':
          fill = '#E74C3C';
          break;
        case 'In Progress':
          fill = '#5858D1';
          break;
        case 'On Hold':
          fill = '#8381FF';
          break;
        case 'Cancelled':
          fill = '#E71600';
          break;
        case 'Completed(Doctor-Unavailable)':
          fill = '#A9A9A9';
          break;
        case 'Completed(Visit-Complete)':
          fill = '#07A74A';
          break;
        case 'Completed(Refused-To-Meet)':
          fill = '#A9A9A9';
          break;
        case 'Submitted':
          fill = '#42526E';
          break;
        case 'Rescheduled':
          fill = '#9B59B6';
          break;
        default:
          fill = '#CCCCCC';
          break;
      }
      return { key: item.key, value: item.value, fill };
    });
  const tableData = !loading && subOrdinates && subOrdinates !== "isLoading"
    ? subOrdinates.map((row, i) => ({
      ...row,
      fullName: `${row.firstName} ${row.lastName}`,
    }))
    : [];
    const columns = [
      {
        label: "Id",
        accessor: "id",
        cell: (row, index) => (
            <BodySmallMedium text={index + 1} />
        )
      },
      {
        label: `${t("name")}`,
        accessor: "fullName",
        cell: (row) => (
          <div className="avatar-wrapper">
            <div className="avatar-set">
              <p>
                {row.firstName?.charAt(0)}
                {row.lastName?.charAt(0)}
              </p>
            </div>
            <span className="tablecelltext">
              {row.firstName} {row.lastName}
            </span>
          </div>
        )
      },
      {
        label: `${t("designation")}`,
        accessor: "designationName",
        cell: (row) => (
          <span className="tablecelltext">{row.designationName}</span>
        )
      },
      {
        label: `${t("reportsTo")}`,
        accessor: "reportToName",
        cell: (row) => {
          if (!row.reportToName) {
            return <span className="not-available-text">Not Available</span>;
          }
          return <span className="tablecelltext">{row.reportToName}</span>;
        }
      },
      {
        label: `${t("status")}`,
        accessor: "employmentStatusName",
        cell: (row) => (
          <span className="status-badge tablecelltext">
            {row.employmentStatusName !== "Resigned" ? "Active" : "Resigned"}
          </span>
        )
      },
      {
        label: `${t("viewDetails")}`,
        accessor: "actions",
        cell: (row, index) => (
          <Tooltip title="View Detail" arrow>
            <button
              style={{
                background: "none",
                border: "none",
                cursor: "pointer"
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleDetails(row.id, index);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="black"
                fillOpacity="0.56"
                style={{
                  transform: showDetailsForRow[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <path d="M16.59 8.29688L12 12.8769L7.41 8.29688L6 9.70687L12 15.7069L18 9.70687L16.59 8.29688Z" />
              </svg>
            </button>
          </Tooltip>
        )
      }
    ];
    
  const customRowRenderer = (row, index) => {
    return (
      <React.Fragment key={index}>
        <tr className={showDetailsForRow[index] ? "active-row" : ""}>
          {columns.map((column, colIndex) => (
            <td key={colIndex}>
              {column.cell ? column.cell(row, index) : row[column.accessor]}
            </td>
          ))}
        </tr>
        {showDetailsForRow[index] && (
  <tr className="details-row">
    <td colSpan={columns.length} style={{ padding: '10px' }}>
      {tasksTarget.tasksTarget && tasksTarget.tasksTarget.length > 0 ? (
                <div>
                  <div className="all_boxes">
                    <div className="first_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[0]?.value || 0}
                      </p>
                      <p className="key">
                        {t("total")}
                      </p>
                    </div>
                    <div className="second_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[1]?.value || 0}
                      </p>
                      <p className="key">
                       {t("created")}
                      </p>
                    </div>
                    <div className="third_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[2]?.value || 0}
                      </p>
                      <p className="key">
                        {t("inReview")}
                      </p>
                    </div>
                    <div className="four_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[3]?.value || 0}
                      </p>
                      <p className="key">
                        {t("approved")}
                      </p>
                    </div>
                    <div className="five_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[5]?.value || 0}
                      </p>
                      <p className="key">
                        {t("inProgress")}
                      </p>
                    </div>
                  </div>
                  <div className="all_boxes">
                    <div className="six_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[4]?.value || 0}
                      </p>
                      <p className="key">
                        {t("rejected")}
                      </p>
                    </div>
                    <div className="seven_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[7]?.value || 0}
                      </p>
                      <p className="key">
                        {t("cancelled")}
                      </p>
                    </div>
                    <div className="eight_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[6]?.value || 0}
                      </p>
                      <p className="key">
                        {t("onHold")}
                      </p>
                    </div>
                    <div className="nine_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[12]?.value || 0}
                      </p>
                      <p className="key">
                        {t("reScheduled")}
                      </p>
                    </div>
                    <div className="ten_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[8]?.value || 0}
                      </p>
                      <p className="key">
                        {t("completed")} <br />({t("doctorUnavailable")})
                      </p>
                    </div>
                  </div>

                  <div className="all_boxes">
                    <div className="eleven_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[10]?.value || 0}
                      </p>
                      <p className="key">
                        {t("completed")} <br />({t("refusedToMeet")})
                      </p>
                    </div>
                    <div className="tweleve_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[9]?.value || 0}
                      </p>
                      <p className="key">
                        {t("completed")} <br />({t("visitComplete")})
                      </p>
                    </div>
                    <div className="thirteen_box">
                      <p className="value">
                        {tasksTarget.tasksTarget[11]?.value || 0}
                      </p>
                      <p className="key">
                        {t("submitted")}
                      </p>
                    </div>

                    <div className="pie-chart">
                      <TasksTargetPieChart
                        data={data}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center p-4">
                  No task data available
                </div>
              )}
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  };

  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getSubOrdinates(id, pageNumber, value, query));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  return (
    <>
      <div >
<LoadingOverlay isVisible={isSubordinatesLoading || isLoading} />        <div className="row">
          <div className="col-md-9">

            <br />
            <div
              className="dashboard-nav-tabs"
              style={{
                display: "flex",
                gap: "24px",
                position: "relative",
                padding: "0px 25px",
                borderBottom: "1px solid #DFE4EA",
              }}
            >
              <CustomTab
                label={t("myTasks")}
                isActive={selectedTab === "MY TASKS"}
                onClick={MyTasksChange}
              />
              <CustomTab
                label={t("subOrdinates")}
                isActive={selectedTab === "SubOrdinates"}
                onClick={SubOrdinatesChange}
              />
            </div>
          </div>
        </div>
        {!showMyTask && selectedTab === "SubOrdinates" && (
    <div className="task-target-subordinates" style={{ position: "relative" }}>
    <LoadingOverlay isVisible={isSubordinatesLoading || isLoading} />
            <div className="content-wrapper p-0">
              <div style={{padding :'20px 16px'}}>
              <div className="pagination ">
                <SearchInput
                  setText={setQuery}
                  text={query}
                  placeholder="Search"
                  onChange={handleSearch}
                />

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ minWidth: '80px', marginRight: '10px' }}>
                    <ItemsPerPageSelector
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                    />
                  </div>
                  <CustomPagination
                    currentPage={currentPage}
                    totalItems={totalCount}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                  <GenericFilter
                    showFilters={showFilters}
                    toggleFilters={toggleFilters}
                  />
                </div>
              </div>
              </div>
              <FilterBar showFilters={showFilters} onClearAll={handleClearAllFilters}>
                {/* Date Range Filter */}
                <CustomFilterSelect
                  label="Date Range"
                  width="160px"
                  value={dateRangeFilter}
                  searchable={false}
                  onChange={handleDateRangeChange}
                  options={dateRangeOptions} // Use the same options array you defined above
                />

                {/* Custom Date Pickers - only show when custom range is selected */}
                {customDateRange && (
                  <>
                    <div style={{ width: '150px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="From Date"
                          value={selected.taskFromDate ? dayjs(selected.taskFromDate) : null}
                          onChange={handleFromDateChange}
                          slotProps={{
                            textField: {
                              size: 'small',
                              sx: { width: '100%' }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    <div style={{ width: '150px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="To Date"
                          value={selected.taskToDate ? dayjs(selected.taskToDate) : null}
                          onChange={handleToDateChange}
                          slotProps={{
                            textField: {
                              size: 'small',
                              sx: { width: '100%' }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </>
                )}
              </FilterBar>

            </div>
            <DynamicTable
              columns={columns}
              data={tableData}
              customRowRenderer={customRowRenderer}
              emptyMessage="No subordinates found"
              showPagination={totalCount > 0}
              currentPage={currentPage}
              totalItems={totalCount}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
        )}
        {showMyTask && selectedTab === "MY TASKS" && (
          <>
            {tasksTarget.tasksTarget === "isLoading" &&
              tasksTarget !== undefined && (
                <div style={{ backgroundColor: "#fff !important" }}>
                  <LoadingOverlay isVisible={isLoading}/>
                </div>
              )}
            {tasksTarget.tasksTarget !== "isLoading" &&
              tasksTarget !== undefined && tasksTarget.tasksTarget.length !== 0 && (
                <div>
                  <div className="row mt-2">
                    <div className="col-12 all_boxes">
                      <div className="first_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[0].value}
                        </p>
                        <p className="key">
                          {t("total")}
                        </p>
                      </div>
                      <div className="second_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[1].value}
                        </p>
                        <p className="key">
                          {t("created")}
                        </p>
                      </div>
                      <div className="third_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[2].value}
                        </p>
                        <p className="key">
                          {t("inReview")}
                        </p>
                      </div>

                      <div className="four_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[3].value}
                        </p>
                        <p className="key">
                          {t("approved")}
                        </p>
                      </div>
                      <div className="five_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[5].value}
                        </p>
                        <p className="key">
                          {t("inProgress")}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 all_boxes">
                      <div className="six_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[4].value}
                        </p>
                        <p className="key">
                          {t("rejected")}
                        </p>
                      </div>
                      <div className="seven_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[7].value}
                        </p>
                        <p className="key">
                          {t("cancelled")}
                        </p>
                      </div>
                      <div className="eight_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[6].value}
                        </p>
                        <p className="key">
                          {t("onHold")}
                        </p>
                      </div>
                      <div className="nine_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[12].value}
                        </p>
                        <p className="key">
                         {t("reScheduled")}
                        </p>
                      </div>
                      <div className="ten_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[8].value}
                        </p>
                        <p className="key">
                          {t("completed")} <br />({t("doctorUnavailable")})
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 all_boxes">
                      <div className="eleven_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[10].value}
                        </p>
                        <p className="key">
                          {t("completed")} <br />({t("refusedToMeet")})
                        </p>
                      </div>
                      <div className="tweleve_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[9].value}
                        </p>
                        <p className="key">
                          {t("completed")} <br />({t("visitComplete")})
                        </p>
                      </div>
                      <div className="thirteen_box">
                        <p className="value">
                          {tasksTarget.tasksTarget[11].value}
                        </p>
                        <p className="key">
                          {t("submitted")}
                        </p>
                      </div>

                      <div className="pie-chart">
                        <TasksTargetPieChart
                          data={data}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </>
        )}
      </div>
    </>
  );
};

export default TaskTarget;